import React, {useEffect, useRef, useState} from 'react'
import {createPortal} from "react-dom";
import FetchUtil from "../../../../util/FetchUtil";
import ConfigUtil from "../../../../util/ConfigUtil";
import {NAVIGATION_ITEM} from "../../../../constants/navigationItems";

/**
 * Registrierung im neuen Design, im Stil des LoginDialog. Ersetzt in den neuen Ansichten den RegistrierenDialog
 * (Drawer); registriert wird wie dort über user/registration.
 */
export default function RegistrierenDialog({onClose}) {

    const [username, setUsername] = useState("");
    const [firstname, setFirstname] = useState("");
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [mobil, setMobil] = useState("");
    const [password1, setPassword1] = useState("");
    const [password2, setPassword2] = useState("");
    const [kennwortSichtbar, setKennwortSichtbar] = useState(false);
    const [agb, setAgb] = useState(false);
    const [saving, setSaving] = useState(false);
    const [fehler, setFehler] = useState(undefined);
    const [erfolgreich, setErfolgreich] = useState(false);
    const usernameRef = useRef(null);

    useEffect(() => {
        if (usernameRef.current) {
            usernameRef.current.focus();
        }
    }, []);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                onClose();
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [onClose]);

    const alleFelderGefuellt = username.trim() !== "" && firstname.trim() !== "" && name.trim() !== "" &&
        email.trim() !== "" && password1 !== "" && password2 !== "" && agb;
    const kannRegistrieren = alleFelderGefuellt && !saving;

    const registrieren = (event) => {
        event.preventDefault();
        if (!kannRegistrieren) {
            return;
        }
        setFehler(undefined);
        setSaving(true);
        const url = ConfigUtil.getConfig().resourceUrls.user + "/registration";
        const data = {
            email: email,
            username: username,
            name: name,
            mobil: mobil,
            firstname: firstname,
            password1: password1,
            password2: password2,
        };
        FetchUtil.fetchPost(url,
            data,
            message => {
                setSaving(false);
                if (message) {
                    setFehler(message);
                } else {
                    setErfolgreich(true);
                }
            },
            responseNotOk => {
                setFehler("Fehler: " + responseNotOk.message);
                setSaving(false);
            },
            error => {
                setFehler("Fehler: " + error.message);
                setSaving(false);
            }
        );
    }

    const getKennwortFeld = (label, wert, setWert, autoComplete) => <label className="dhpt-feld">
        <span className="dhpt-feld-label">{label}</span>
        <span className="dhpt-feld-mit-knopf">
            <input type={kennwortSichtbar ? "text" : "password"} className="dhpt-feld-eingabe" autoComplete={autoComplete}
                   value={wert} onChange={(event) => setWert(event.target.value)}/>
            <button type="button" className="dhpt-feld-knopf" aria-label={kennwortSichtbar ? "Kennwort verbergen" : "Kennwort anzeigen"}
                    aria-pressed={kennwortSichtbar} onClick={() => setKennwortSichtbar(!kennwortSichtbar)}>
                <i className={kennwortSichtbar ? "pi pi-eye-slash" : "pi pi-eye"} aria-hidden="true"/>
            </button>
        </span>
    </label>;

    const getFormular = () => <form className="dhpt-login-form" onSubmit={registrieren} noValidate>
        <label className="dhpt-feld">
            <span className="dhpt-feld-label">Benutzername</span>
            <input ref={usernameRef} type="text" className="dhpt-feld-eingabe" autoComplete="username" autoCapitalize="none" spellCheck={false}
                   value={username} onChange={(event) => setUsername(event.target.value)}/>
        </label>
        <div className="dhpt-registrieren-zeile">
            <label className="dhpt-feld">
                <span className="dhpt-feld-label">Vorname</span>
                <input type="text" className="dhpt-feld-eingabe" autoComplete="given-name"
                       value={firstname} onChange={(event) => setFirstname(event.target.value)}/>
            </label>
            <label className="dhpt-feld">
                <span className="dhpt-feld-label">Name</span>
                <input type="text" className="dhpt-feld-eingabe" autoComplete="family-name"
                       value={name} onChange={(event) => setName(event.target.value)}/>
            </label>
        </div>
        <label className="dhpt-feld">
            <span className="dhpt-feld-label">E-Mail</span>
            <input type="email" className="dhpt-feld-eingabe" autoComplete="email" autoCapitalize="none" spellCheck={false}
                   value={email} onChange={(event) => setEmail(event.target.value)}/>
        </label>
        <label className="dhpt-feld">
            <span className="dhpt-feld-label">Mobil (optional)</span>
            <input type="tel" className="dhpt-feld-eingabe" autoComplete="tel"
                   value={mobil} onChange={(event) => setMobil(event.target.value)}/>
            <span className="dhpt-hinweis dhpt-registrieren-feldhinweis">Sofern du dich mit dem Account bei Events anmelden möchtest, musst du deine Handynummer angeben.</span>
        </label>
        {getKennwortFeld("Kennwort", password1, setPassword1, "new-password")}
        {getKennwortFeld("Kennwort wiederholen", password2, setPassword2, "new-password")}

        <p className="dhpt-hinweis dhpt-registrieren-text">
            Mit dem Klick auf „Registrieren“ willige ich in die Verarbeitung meiner personenbezogenen Daten gemäß der{" "}
            <a href={NAVIGATION_ITEM.DATENSCHUTZ.route} target="_blank" rel="noreferrer">Datenschutzerklärung</a> von darthelfer.de ein.
        </p>
        <label className="dhpt-registrieren-agb">
            <input type="checkbox" checked={agb} onChange={() => setAgb(!agb)}/>
            <span>Ich stimme der <a href={NAVIGATION_ITEM.AGB.route} target="_blank" rel="noreferrer">AGB</a> von darthelfer.de zu.</span>
        </label>

        {fehler && <p className="dhpt-login-fehler" role="alert"><i className="pi pi-exclamation-triangle" aria-hidden="true"/>{fehler}</p>}
        <button type="submit" className="dhpt-knopf-primaer" disabled={!kannRegistrieren}>
            {saving ? <><i className="pi pi-spin pi-spinner" aria-hidden="true"/>Registrieren …</> : <><i className="pi pi-user-plus" aria-hidden="true"/>Registrieren</>}
        </button>
    </form>;

    const getErfolg = () => <div className="dhpt-dialog-erfolg" role="status">
        <i className="pi pi-envelope" aria-hidden="true"/>
        <p>Bitte prüfe deine Mails (auch SPAM) und bestätige deine Registrierung innerhalb von 2 Stunden. Danach läuft deine
            Registrierung ab und du musst eventuell eine weitere Registrierung durchführen.</p>
        <button type="button" className="dhpt-knopf-primaer" onClick={() => onClose()}>Zurück zum Login</button>
    </div>;

    const dialog = <div className="dhpt-modal-hintergrund" onMouseDown={(event) => {
        // Klick neben den Dialog schließt ihn
        if (event.target === event.currentTarget) {
            onClose();
        }
    }}>
        <div className="dhpt-modal dhpt-registrieren" role="dialog" aria-modal="true" aria-labelledby="dhpt-registrieren-titel">
            <div className="dhpt-modal-kopf">
                <h2 id="dhpt-registrieren-titel" className="dhpt-modal-titel"><i className="pi pi-user-plus" aria-hidden="true"/>Registrierung</h2>
                <button type="button" className="dhpt-modal-schliessen" aria-label="Schließen" onClick={() => onClose()}>
                    <i className="pi pi-times" aria-hidden="true"/>
                </button>
            </div>
            {erfolgreich ? getErfolg() : getFormular()}
        </div>
    </div>;

    // direkt in die Seite hängen (Farbvariablen aus .dhpt-seite), unabhängig vom Ort des Aufrufs
    const ziel = document.querySelector(".dhpt-seite");
    return ziel ? createPortal(dialog, ziel) : dialog;
}
